import { Component, OnInit, Input } from '@angular/core';
import { CNInsurance } from 'src/app/models/cninsurance';

@Component({
  selector: 'app-insurance-selection',
  templateUrl: './insurance-selection.component.html',
  styleUrls: ['./insurance-selection.component.scss']
})
export class InsuranceSelectionComponent implements OnInit {

  theinsurance: CNInsurance;

  public insuDescription: string;

  constructor() { }

  ngOnInit(): void {
  }

  @Input() set insurance(ainsurance: CNInsurance) {
    this.theinsurance = ainsurance;
    if (this.theinsurance) {
      this.insuDescription = this.theinsurance.getProperty('code') + ' ' + this.theinsurance.getProperty('name');
    }
  }
}
